import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useTranslation } from "react-i18next";
import CommentListRow from "./CommentListRow";

const CommentList = ({ setCommentIdToBeDeleted, setConfirmationModalIsShown }) => {
  const { t } = useTranslation();
  const comments = useSelector((state) => state.candidate.comments);
  const dispatch = useDispatch();

  return (
    <>
      {comments.length > 0 ? (
        <>
          {comments.map((comment, index) => {
            const lastItem = index === comments.length - 1;
            return (
              <CommentListRow
                key={index}
                comment={comment}
                lastItem={lastItem}
                setCommentIdToBeDeleted={setCommentIdToBeDeleted}
                setConfirmationModalIsShown={setConfirmationModalIsShown}
              />
            );
          })}
        </>
      ) : (
        <>
          <Row className=" mx-0 justify-content-center">
            <Col xs="auto" className="text-20 text-color-gray-light fw-medium">
              {t("noCommentsAvailableLabel")}
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default CommentList;
